import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { apiClient, setAdminToken } from '../../../api/client';
import { AdminUser } from '../../../types';
import { adminAuthActions } from './index';

function* loginSaga(action: ReturnType<typeof adminAuthActions.loginRequest>) {
  try {
    const { data } = yield call(apiClient.post, '/api/admin/auth/login', action.payload);
    setAdminToken(data.token);
    yield put(adminAuthActions.loginSuccess({ user: data.user as AdminUser, token: data.token }));
  } catch (err: unknown) {
    const message =
      (err as { response?: { data?: { message?: string } } })?.response?.data?.message ||
      'Login failed';
    yield put(adminAuthActions.loginFailure(message));
  }
}

function* fetchMeSaga() {
  try {
    const { data } = yield call(apiClient.get, '/api/admin/auth/me');
    yield put(adminAuthActions.setUser(data.user as AdminUser));
  } catch {
    yield put(adminAuthActions.logout());
    setAdminToken(null);
  }
}

function* adminAuthBootstrapSaga() {
  const token = localStorage.getItem('sportshub_admin_token');
  if (token) {
    setAdminToken(token);
    yield call(fetchMeSaga);
  }
}

export function* adminAuthSaga() {
  yield fork(adminAuthBootstrapSaga);
  yield takeLatest(adminAuthActions.loginRequest.type, loginSaga);
  yield takeLatest(adminAuthActions.loginSuccess.type, function* () {
    // session established
  });
}
